// components/GoogleMapsProvider.tsx
'use client';

import { useJsApiLoader } from '@react-google-maps/api';
import { createContext, useContext } from 'react';

const libraries: ("places" | "geometry")[] = ["places", "geometry"];

interface GoogleMapsContextType {
  isLoaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({ isLoaded: false });

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export const GoogleMapsProvider = ({ children }: { children: React.ReactNode }) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
        libraries,
    });

    return (
        <GoogleMapsContext.Provider value={{ isLoaded }}>
        {children}
        </GoogleMapsContext.Provider>
    );
};